/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TransportCompanyResVo
 */
export interface TransportCompanyResVo {
    /**
     * 主键ID
     * @type {number}
     * @memberof TransportCompanyResVo
     */
    id?: number;
    /**
     * 运输公司名称（根据语言返回中文或韩文）
     * @type {string}
     * @memberof TransportCompanyResVo
     */
    name?: string;
    /**
     * 运输公司编码
     * @type {string}
     * @memberof TransportCompanyResVo
     */
    transportCompanyCode?: string;
    /**
     * 是否可用：0-不可用 1-可用
     * @type {number}
     * @memberof TransportCompanyResVo
     */
    enable?: number;
}

/**
 * Check if a given object implements the TransportCompanyResVo interface.
 */
export function instanceOfTransportCompanyResVo(value: object): value is TransportCompanyResVo {
    return true;
}

export function TransportCompanyResVoFromJSON(json: any): TransportCompanyResVo {
    return TransportCompanyResVoFromJSONTyped(json, false);
}

export function TransportCompanyResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TransportCompanyResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'transportCompanyCode': json['transportCompanyCode'] == null ? undefined : json['transportCompanyCode'],
        'enable': json['enable'] == null ? undefined : json['enable'],
    };
}

export function TransportCompanyResVoToJSON(json: any): TransportCompanyResVo {
    return TransportCompanyResVoToJSONTyped(json, false);
}

export function TransportCompanyResVoToJSONTyped(value?: TransportCompanyResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'transportCompanyCode': value['transportCompanyCode'],
        'enable': value['enable'],
    };
}

